import i18n from "./i18n";

export const dropSizes = [
    i18n.t('FILTER_CUSTOM_REQUEST'),
    i18n.t('FILTER_NORMAL_LOAD')
]